export const semicolonRegexp = new RegExp(';');
